<template>
  <div class="main">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网站设置</el-breadcrumb-item>
      <el-breadcrumb-item>首页视频</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form class="operation" ref="form" label-width="80px" :inline="true">
      <el-form-item>
        <el-button type="primary" size="small" @click="isAdd">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          class="upload-demo"
          action="http://test.api.chongyi.xiaoxxx.com/admin/upload"
          :headers='headers'
          :on-success="sucess2"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          ref="upload">
          <el-button >上传首页视频</el-button>
        </el-upload>
     </el-form-item>
      <el-form-item>
        <el-button type="success"  @click="videoVisible = true">查看当前视频</el-button>
      </el-form-item>
      
    </el-form>
    <el-dialog
        title="当前视频"
        :visible.sync="videoVisible"
        width="550px"
        :before-close="videoClose">
          <div class="video">
            <video width="100%" height="100%" :src="videoUrl" controls></video>
          </div> 
        <span slot="footer" class="dialog-footer">
          <el-button @click="videoVisible = false">取 消</el-button>
          <el-button type="primary" @click="videoVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    <el-table
      :data="videoData"
      stripe
      border
      style="width: 100%">
      <el-table-column
        label="#"
        type="index"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        label="背景图"
        width="800"
        align="center">
        <template slot-scope="scope">
          <img :src="scope.row.images" alt="" height=100px >
        </template>
      </el-table-column>
       <el-table-column
        label="权重"
        prop="order"
        width="300"
        align="center">
       </el-table-column>
      <el-table-column
        label="操作"
        width="300"
        align="center">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="addVisible"
      width="800px"
      :before-close="handleClose">
      <el-form ref="form" label-width="80px" :model="queryForm">
         <el-form-item label="权重" prop="order"
          :rules="[
            { type: 'number', message: '权重必须为数字值'}
          ]">
             <el-input v-model.number="queryForm.order" size="mini"></el-input>
         </el-form-item>
        <el-form-item label="背景图" :rules="[
          { required: true, message: '不能为空'},
        ]">
          <el-upload
            class="upload-demo"
            action="http://test.api.chongyi.xiaoxxx.com/admin/upload"
             accept="image/png, image/jpeg"
            :headers='headers'
            :on-success="sucess1"
             multiple
            :limit="3"
             ref="upload"
            :on-exceed="handleExceed">
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
             <div slot="tip" class="el-upload__tip">只能上传jpg/png文件(建议上传图片大小1920*1080)</div>
          </el-upload>
          <div class="visibleImg">
            <img width="80%" :src="queryForm.images" alt="">
          </div>
        </el-form-item>
        <!-- <el-form-item label="视频">
         
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="isOk">确 定</el-button>
      </span>
    </el-dialog>
<!--分页-->
 <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5,10,15]"
      :page-size="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoVisible:false,
      addVisible: false,
      total:0,
       pageVal:1,
       pageSize:5,
       currentPage: 1,
       id:null,
       videoUrl:'',
     
       flag:1,
       headers:{
         Authorization: ''
       },
       queryForm:{
        order:0,
        images:''
      },
      videoData: [
         {
          order:'',
          img: '',
        },
        {
          order:'',
          img: '',
        }
      ],
    }
  },
  methods: {
    getList () {
      this.$http.post('/admin/index/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1
      }).then( (res)=> {
        // console.log(res.data.data)
        var code=res.data.code;
        if(code===0){
        this.videoData=res.data.data.lists;
        this.total=res.data.data.allCount
        // console.log(res.data.data)
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    //编辑
    compile (row) {
      this.flag=0;
      this.addVisible = true;
      // console.log(row.id)
      this.id=row.id
      this.$http.post('/admin/index/getInfo', {
           id:row.id
      }).then( (res)=> {
       var code=res.data.code;
       if (code===0){
        //  console.log(res.data.data.info.order)
         this.queryForm.order=res.data.data.info.order
         this.queryForm.images=res.data.data.info.images
         this.getList()
       }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    handleClose () {
      this.addVisible = false
    },
     videoClose(done) {
       this.videoVisible=false
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
    
    //保存
    isOk(){
      this.addVisible = false;
      if(this.flag!=1){
          this.$http.post('/admin/index/update', {
          id:this.id,
          images:this.queryForm.images,
          order:this.queryForm.order
          
      }).then( (res)=> {
        // console.log(res)
       var code=res.data.code;
       if (code===0){
         this.$message({
          message: '保存成功',
          type: 'success'
        });
         this.getList()
       }
      }).catch(function (error) {
        //  console.log(error);
          });
      }else{
        //新增
         this.$http.post('/admin/index/create', {
          images:this.queryForm.images,
          order:this.queryForm.order
      }).then( (res)=> {
        // console.log(res)
       var code=res.data.code;
       if (code===0){
         this.$message({
          message: '新增成功',
          type: 'success'
        });
         this.getList()
       }else if(code===-1){
           this.$message.error("请选择图片");
       }
      }).catch(function (error) {
        //  console.log(error);
     });
   }
 
    },
    //新增
    isAdd(){
        this.flag=1;
        this.addVisible = true;
        this.$refs.upload.clearFiles();
        this.queryForm.images=""
    },
    //删除
    del(row){
       this.id=row.id
       this.$http.post('/admin/index/delete', {
           id:row.id
      }).then( (res)=> {
       var code=res.data.code;
       if (code===0){
           this.$message({
            message: '删除成功！',
            type: 'success'
          });
         this.getList()
       }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    //上传图片回调
    sucess1(response, file, fileList){
        // console.log(response.data.url)
       this.queryForm.images='http://test.api.chongyi.xiaoxxx.com/'+response.data.url
     
    },
    //上传视频回调
    sucess2(response, file, fileList){
        this.videoUrl= 'http://test.api.chongyi.xiaoxxx.com/'+response.data.url
        this.$http.post('/admin/index/uploadVideo', {
           id:1,
           videoUrl: this.videoUrl
        }).then( (res)=> {
        // console.log(res)
        var code=res.data.code;
        if (code===0){
           this.headers.Authorization= window.localStorage.getItem("user_token");
           this.$http.post('/admin/index/getVideoUrl', {
              
          }).then( (res)=> {
            // console.log(res)
          var code=res.data.code;
          if (code===0){
            this.videoUrl=res.data.data.videoUrl
          }
          }).catch(function (error) {
            // console.log(error);
        });
       }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    handleRemove () {},
    beforeRemove () {},
    handleExceed () {},
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
         this.pageSize=val;
         this.getList()
      },
    handleCurrentChange(val) {
        //  console.log(`当前页: ${val}`);
         this.pageVal=val
         this.getList()
      }
  },
  created(){
    //渲染列表
    this.getList()
    this.headers.Authorization= window.localStorage.getItem("user_token");
       this.$http.post('/admin/index/getVideoUrl', {
          
      }).then( (res)=> {
        // console.log(res)
       var code=res.data.code;
       if (code===0){
         this.videoUrl=res.data.data.videoUrl
       }
      }).catch(function (error) {
        //  console.log(error);
     });
  }
}
</script>
<style scoped>
.operation {
  /* width: 0; */
  margin-bottom: 20px;
}
.visibleImg {
  width: 100%;
  text-align: center;
  border: 1px dashed #ccc;
  border-radius: 10px;
}
.visibleImg img{
  margin-top: 10px;
}
.video{
  margin-top: 20px;
  width: 500px;
  height: 300px;
}
</style>
<style>
.el-pagination{
  text-align: center;
  margin-top: 50px;
}

</style>



// WEBPACK FOOTER //
// src/pages/backPages/video.vue